import { render, staticRenderFns } from "./transactionrecord.vue?vue&type=template&id=640209ca&scoped=true&"
import script from "./transactionrecord.vue?vue&type=script&lang=js&"
export * from "./transactionrecord.vue?vue&type=script&lang=js&"
import style0 from "./transactionrecord.vue?vue&type=style&index=0&id=640209ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640209ca",
  null
  
)

export default component.exports